const showMoreDocInfoBtn = document.querySelector('.js--doc_show_more')
const showMoreDocAnnotationBtn = document.querySelector('.js--annotation_show_more')
const annotation = document.querySelector('.js--annotation');
const scrollToTopBtn = document.querySelector('.js--scroll_to_top_button')
const scrollToRelatedBtn = document.querySelector('.js--scroll_to_related_button')
const relatedElements = document.querySelector('.js--related_post')

    if(showMoreDocInfoBtn) {
      showMoreDocInfoBtn.addEventListener('click', function () {
        const additionalInfo = document.querySelector('.js--doc_additional_info');
        const button = this;

        if (additionalInfo.classList.contains('show')) {
          additionalInfo.classList.remove('show');
          additionalInfo.style.height = '0';
          button.classList.remove('less');
          button.querySelector('span').textContent = button.getAttribute('data-more-text');
        } else {
          additionalInfo.classList.add('show');
          additionalInfo.style.height = additionalInfo.scrollHeight + 'px';
          button.classList.add('less');
          button.querySelector('span').textContent = button.getAttribute('data-less-text');
        }
      });
    }
if (annotation && showMoreDocAnnotationBtn) {
  const textLength = annotation.textContent.trim().length;

  if (textLength < 312) {
    showMoreDocAnnotationBtn.style.display = 'none'; // Скрываем кнопку
  } else {
    showMoreDocAnnotationBtn.addEventListener('click', function () {
      const button = this;

      if (annotation.classList.contains('show')) {
        annotation.classList.remove('show');
        button.classList.remove('less');
        button.querySelector('span').textContent = button.getAttribute('data-more-text');
      } else {
        annotation.classList.add('show');
        button.classList.add('less');
        button.querySelector('span').textContent = button.getAttribute('data-less-text');
      }
    });
  }
}

if (scrollToTopBtn || scrollToRelatedBtn) {
  window.onscroll = function () { scrollFunction() };

  function scrollFunction() {
    if (scrollToTopBtn) {
      const footer = document.querySelector('.footer');
      const isFooterVisible = footer.getBoundingClientRect().top <= window.innerHeight;
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100 && !isFooterVisible) {
        scrollToTopBtn.style.display = "flex";
      } else {
        scrollToTopBtn.style.display = "none";
      }
    }

    if (scrollToRelatedBtn && relatedElements) {
      const footer = document.querySelector('.footer');
      const isFooterVisible = footer.getBoundingClientRect().top <= window.innerHeight;
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100 && !isFooterVisible) {
        scrollToRelatedBtn.style.display = "flex";
      } else {
        scrollToRelatedBtn.style.display = "none";
      }

    }
  }

  if (scrollToTopBtn) {
    scrollToTopBtn.addEventListener('click', function () {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    });
  }

  if (scrollToRelatedBtn && relatedElements) {
    scrollToRelatedBtn.addEventListener('click', function () {
      const elementPosition = relatedElements.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - 100;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    });
  }
}


